// แปลง error จาก axios เป็นข้อความให้ลูกค้ารู้ว่าปัญหาอยู่ที่อินเทอร์เน็ต, รูป หรือ server ของเรา
// isUpload = true เมื่อเป็น request อัพโหลดรูป (status 4xx จะถือว่าเป็นปัญหาที่ไฟล์รูป)
export function getApiErrorMessage (error, isThai, isUpload = false) {
  const status = error && error.response ? error.response.status : null

  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return isThai
      ? 'ไม่มีการเชื่อมต่ออินเทอร์เน็ต กรุณาตรวจสอบอินเทอร์เน็ตแล้วลองอีกครั้ง'
      : 'No internet connection. Please check your connection and try again.'
  }
  if (error && error.code === 'ECONNABORTED') {
    return isThai
      ? 'ระบบตอบสนองช้ากว่าปกติ กรุณาลองอีกครั้ง'
      : 'The system is responding slowly. Please try again.'
  }
  if (isUpload && status >= 400 && status < 500) {
    return isThai
      ? 'ไฟล์รูปไม่ถูกต้องหรือมีขนาดใหญ่เกินไป กรุณาเลือกรูปใหม่'
      : 'The image file is invalid or too large. Please choose another image.'
  }
  return isThai
    ? 'ระบบขัดข้องชั่วคราว กรุณาลองอีกครั้งในอีกสักครู่'
    : 'The system is temporarily unavailable. Please try again in a moment.'
}

export function getImageErrorMessage (isThai) {
  return isThai
    ? 'ไม่สามารถอ่านไฟล์รูปนี้ได้ กรุณาเลือกรูปใหม่ (รองรับ JPG, PNG)'
    : 'This image file cannot be read. Please choose another image (JPG, PNG supported).'
}



// WEBPACK FOOTER //
// ./src/utils/apiErrorMessage.js